import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77646f66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bigbox" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "setting" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("批量审核")
const _hoisted_5 = { class: "tablebox" }
const _hoisted_6 = {
  key: 0,
  class: "numtext1"
}
const _hoisted_7 = {
  key: 1,
  class: "numtext2"
}
const _hoisted_8 = {
  key: 2,
  class: "numtext3"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("审核")
const _hoisted_13 = { class: "pushTable" }
const _hoisted_14 = { class: "dialog-footer" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_16 = { class: "pushTable" }
const _hoisted_17 = {
  key: 0,
  class: "numtext2"
}
const _hoisted_18 = {
  key: 1,
  class: "numtext3"
}
const _hoisted_19 = { class: "dialog-footer" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("关闭")
const _hoisted_21 = { class: "pushTable" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("审核通过")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("审核不通过")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "反馈详情：", -1))
const _hoisted_25 = { class: "dialog-footer" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_28 = { class: "pushTable" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"red"} }, "说明: 审核后商品审核状态将无法修改且商品规格无法删除，请谨慎操作", -1))
const _hoisted_30 = { style: {"margin":"10px 0"} }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("审核通过")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("审核不通过")
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "反馈详情：", -1))
const _hoisted_34 = { class: "dialog-footer" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pageheader = _resolveComponent("Pageheader")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Publicform = _resolveComponent("Publicform")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_MyTable = _resolveComponent("MyTable")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Pageheader, {
      title: "商品审核",
      img: _ctx.headerimg,
      text: "商品总库添加的商品将作为模板商品，主动推送给商户，商户可根据实际需要选择是否更新商品库"
    }, null, 8, ["img"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Publicform, {
          formList: _ctx.state.formList,
          formEditObj: _ctx.state.baseformList,
          rules: _ctx.state.rules,
          ref: "addAndEditDom",
          onChangeSelect: _ctx.changeSelect,
          onSubmitForm: _ctx.submitForm
        }, {
          title: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "商品标题" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.selectData.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectData.title) = $event)),
                  class: "select",
                  type: "text",
                  placeholder: "请输入商品标题",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          branNo: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "商品品牌" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "select",
                  clearable: "",
                  modelValue: _ctx.selectData.branNo,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectData.branNo) = $event)),
                  placeholder: "请选择商品品牌"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brandlistData, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.brandNo,
                        label: item.name,
                        value: item.brandNo
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          code: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "商品货号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.selectData.code,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectData.code) = $event)),
                  class: "select",
                  type: "text",
                  placeholder: "请输入商品货号",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          selectThree: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "商品分类" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "select",
                  onChange: _cache[3] || (_cache[3] = (val) => _ctx.changeSelect(val, 1)),
                  clearable: "",
                  modelValue: _ctx.selectData.firstGoodTypeId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectData.firstGoodTypeId) = $event)),
                  placeholder: "请选择一级分类"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSimpleArr1, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "select",
                  onChange: _cache[5] || (_cache[5] = (val) => _ctx.changeSelect(val, 2)),
                  clearable: "",
                  modelValue: _ctx.selectData.twoGoodTypeId,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectData.twoGoodTypeId) = $event)),
                  placeholder: "请选择二级分类"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSimpleArr2, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "select",
                  onChange: _cache[7] || (_cache[7] = (val) => _ctx.changeSelect(val, 3)),
                  clearable: "",
                  modelValue: _ctx.selectData.threeGoodTypeId,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectData.threeGoodTypeId) = $event)),
                  placeholder: "请选择三级分类"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listSimpleArr3, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          applyStatus: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "审核状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "select",
                  clearable: "",
                  modelValue: _ctx.selectData.applyStatus,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectData.applyStatus) = $event)),
                  placeholder: "请选择审核状态"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "待审核",
                      value: "0"
                    }),
                    _createVNode(_component_el_option, {
                      label: "审核通过",
                      value: "1"
                    }),
                    _createVNode(_component_el_option, {
                      label: "审核不通过",
                      value: "2"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          from: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                color: "#FCA616",
                disabled: _ctx.isButtonFlag,
                style: {"color":"#fff"},
                onClick: _ctx.Batchaudit,
                round: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ])
          ]),
          _: 1
        }, 8, ["formList", "formEditObj", "rules", "onChangeSelect", "onSubmitForm"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_MyTable, {
            isLoading: _ctx.tableloading,
            tableData: _ctx.tableData,
            isHeight: false,
            ifselection: true,
            isPagination: true,
            isIndex: false,
            pageSize: _ctx.selectData.pageSize,
            total: _ctx.TotalPageTable,
            currentPage: _ctx.selectData.pageNum,
            tableColumn: _ctx.tableColumn,
            onHandleSelectionChange: _ctx.handleSelectionChange,
            onHandleSelectAll: _ctx.handleSelectAll,
            onGetRowKey: _ctx.getRowKey,
            onHandleCurrentChange: _ctx.handleCurrentChangeTable
          }, {
            selection: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                selectable: _ctx.checkSelectable,
                "reserve-selection": true,
                width: "55"
              }, null, 8, ["selectable"])
            ]),
            examine: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "审核状态",
                align: "center",
                width: "370px"
              }, {
                default: _withCtx(({ row }) => [
                  (row.applyStatus == 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "待审核"))
                    : (row.applyStatus == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "审核通过"))
                      : (row.applyStatus == 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "审核不通过"))
                        : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    class: "numtext4",
                    onClick: ($event: any) => (_ctx.examineDetails(row))
                  }, "审核详情", 8, _hoisted_9)
                ]),
                _: 1
              })
            ]),
            specifications: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "规格",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createElementVNode("span", {
                    onClick: ($event: any) => (_ctx.seeSpecifications(row.productAuditSkuDtos)),
                    style: {"color":"#0981ff","cursor":"pointer"}
                  }, "查看规格", 8, _hoisted_10)
                ]),
                _: 1
              })
            ]),
            slotName: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "操作",
                width: "170"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_button, {
                    color: "#0981FF",
                    onClick: ($event: any) => (_ctx.details(row)),
                    round: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (row.applyStatus != 1)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        color: "#FCA616",
                        onClick: ($event: any) => (_ctx.auditClick(row)),
                        style: {"color":"#fff"},
                        round: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["isLoading", "tableData", "pageSize", "total", "currentPage", "tableColumn", "onHandleSelectionChange", "onHandleSelectAll", "onGetRowKey", "onHandleCurrentChange"])
        ]),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.pushDisplay,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.pushDisplay) = $event)),
          title: "查看全部规格",
          width: "700px"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_14, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.pushDisplay = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_MyTable, {
                ifselection: false,
                isHeight: false,
                isPagination: true,
                isIndex: true,
                tableData: _ctx.tableData2.slice((_ctx.guigeCurrent - 1) * _ctx.pageSize, _ctx.guigeCurrent * _ctx.pageSize),
                tableColumn: _ctx.tableColumn2,
                pageSize: _ctx.pageSize,
                total: _ctx.tableData2.length,
                currentPage: _ctx.guigeCurrent,
                onHandleCurrentChange: _ctx.handleCurrentChange
              }, null, 8, ["tableData", "tableColumn", "pageSize", "total", "currentPage", "onHandleCurrentChange"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.auditDisplay,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.auditDisplay) = $event)),
          title: "审核详情",
          width: "700px"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_19, [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.auditDisplay = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_MyTable, {
                ifselection: false,
                isHeight: false,
                isPagination: false,
                isIndex: true,
                tableData: _ctx.tableData3,
                tableColumn: _ctx.tableColumn3
              }, {
                result: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "审核结果",
                    align: "center"
                  }, {
                    default: _withCtx(({ row }) => [
                      (row.result == 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, "已通过"))
                        : (row.result == 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, "未通过"))
                          : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["tableData", "tableColumn"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.auditProductDisplay,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.auditProductDisplay) = $event)),
          title: "审核商品",
          width: "700px"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_25, [
              _createVNode(_component_el_button, {
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.auditProductDisplay = false)),
                class: "cancelBtn"
              }, {
                default: _withCtx(() => [
                  _hoisted_26
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.auditProduct
              }, {
                default: _withCtx(() => [
                  _hoisted_27
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_el_form, {
                "label-width": "50",
                modelValue: _ctx.auditForm,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.auditForm) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "商品名称：" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.auditForm.title), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: _ctx.auditForm.result,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.auditForm.result) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, { label: "0" }, {
                            default: _withCtx(() => [
                              _hoisted_22
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: "1" }, {
                            default: _withCtx(() => [
                              _hoisted_23
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _hoisted_24,
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        modelValue: _ctx.auditForm.auditInfo,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.auditForm.auditInfo) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_dialog, {
          modelValue: _ctx.BatchauditDataDisplay,
          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.BatchauditDataDisplay) = $event)),
          title: "批量审核",
          width: "700px"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_34, [
              _createVNode(_component_el_button, {
                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.BatchauditDataDisplay = false)),
                class: "cancelBtn"
              }, {
                default: _withCtx(() => [
                  _hoisted_35
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.BatchauditProduct
              }, {
                default: _withCtx(() => [
                  _hoisted_36
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_el_form, {
                "label-width": "50",
                modelValue: _ctx.BatchauditForm,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.BatchauditForm) = $event))
              }, {
                default: _withCtx(() => [
                  _hoisted_29,
                  _createElementVNode("p", _hoisted_30, "已选商品数：" + _toDisplayString(_ctx.BatchauditData.length), 1),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio_group, {
                        modelValue: _ctx.BatchauditForm.result,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.BatchauditForm.result) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, { label: "0" }, {
                            default: _withCtx(() => [
                              _hoisted_31
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: "1" }, {
                            default: _withCtx(() => [
                              _hoisted_32
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _hoisted_33,
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        modelValue: _ctx.BatchauditForm.auditInfo,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.BatchauditForm.auditInfo) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ], 64))
}